/* eslint no-shadow: ["error", { "allow": ["state"] }] */
import _ from 'lodash';
import { loadCurrentUser, getChatUser } from '@/auth/api';

const state = {
  isLoading: false,
  currentUser: null,
  environment: null,
  chatToken: '',
};

const getters = {
  isLoading: (state) => state.isLoading,
  currentUser: (state) => state.currentUser,
  environment: (state) => state.environment,
  chatToken: (state) => state.chatToken,
};

const mutations = {
  setIsCurrentUserLoading(state, isLoading) {
    state.isLoading = isLoading;
  },
  setCurrentUser(state, currentUser) {
    state.currentUser = _.cloneDeep(currentUser);
  },
  setEnvironment(state, environment) {
    state.environment = _.cloneDeep(environment);
  },
  destoryCurrentUser(state) {
    state.currentUser = null;
  },
  setChatToken(state, token) {
    state.chatToken = token;
  },
  destoryChatToken(state) {
    state.chatToken = '';
  },
};

const actions = {
  async loadCurrentUser({ state, commit }) {
    commit('setIsCurrentUserLoading', true);
    if (!state.currentUser) {
      const response = await loadCurrentUser();
      commit('setCurrentUser', response.data.currentAccount);
      commit('setEnvironment', response.data.environment);
      const chatToken = await getChatUser(response.data.currentAccount);
      commit('setChatToken', chatToken.data);
    }
    commit('setIsCurrentUserLoading', false);
  },
  setCurrentUser({ commit }, currentUser) {
    commit('setCurrentUser', currentUser);
  },
  setEnvironment({ commit }, environment) {
    commit('setEnvironment', environment);
  },
  setIsCurrentUserLoading({ commit }, isLoading) {
    commit('setIsCurrentUserLoading', isLoading);
  },
  destoryCurrentUser({ commit }) {
    commit('destoryCurrentUser');
    commit('destoryChatToken');
  },
  setChatToken({ commit }, token) {
    commit('setChatToken', token);
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
